let orderSendBtn = document.querySelectorAll('.order-send')

if(orderSendBtn.length) {
    for(let elem of orderSendBtn) {
        elem.addEventListener('click', (e) => {
            e.preventDefault()

            let wrapper = elem.closest('section, .form, form')
            let type = 'request'
            let fields = {
                name: {
                    required: true
                },
                phone: {
                    required: true
                },
                email: {
                    required: false
                },
                address: {
                    required: false
                },
                service: {
                    required: true
                },
                help: {
                    required: false
                }
            }
            let data = {}
            let errors = 0
            
            for(let key in fields) {
                let value = fields[key]
                let {required} = value
                let field = wrapper.querySelector('.' + key)

                if(field){
                    let val = field.getValue()
        
                    if(required){
                        errors += field.check()
                    }
        
                    data[key] = val
                }
            }
        
            if(!errors){
                elem.disable(true)

                grecaptcha.ready(function() {
                    grecaptcha.execute('6LcZa7ogAAAAAN-up2sHCisY1gYx5KnQXa3atbfs', {action: 'submit'}).then(function(token) {
                        requestAjax('send_request', {type, data, token}, (res) => {  
                            if(res == 'success') {
                                for(let key in fields) {
                                    let field = wrapper.querySelector('.' + key)
                            
                                    if(field){
                                        field.clear()
                                    }
                                }
            
                                if(!window.debug) {
                                    window.location.href = '/thank-you/'
                                }
                            } else {
                                add_notif({
                                    title: 'Error',
                                    text: 'Something went wrong',
                                    color: 'red',
                                    icon: 'error'
                                })
                            }
                        })
                    })
                })
            }else{
                add_notif({
                    title: 'Error',
                    text: 'Placeholder all fields',
                    icon: 'error',
                    color: 'red',
                    timeout: 3000,
                })
            }
        })
    }
}